<template>
  <div class="step_four">
    <div class="blue_border">
      {{ $t('ifttt.light') }}
    </div>
    <div class="step rhythm_step rhythm_step3">
      <el-steps
        :space="380"
        :active="LightStep"
        align-center
        finish-status="success"
      >
        <el-step
          class="text-button"
          :title="'1.'+$t('ifttt.light01')"
          @click.native="stepchange(1)"
        />
        <el-step
          class="text-button"
          :title="'2.'+$t('ifttt.light00')"
          @click.native="stepchange(2)"
        />
        <el-step
          class="text-button"
          :title="'3.'+$t('ifttt.light02')"
          @click.native="stepchange(3)"
        />
        <el-step
          class="text-button"
          :title="'4.'+$t('ifttt.light03')"
          @click.native="stepchange(4)"
        />
        <el-step
          class="text-button"
          :title="'5.'+$t('ifttt.light04')"
          @click.native="stepchange(5)"
        />
      </el-steps>
    </div>
    <template v-if="LightStep == 2">
      <div class="dialogGroup_cont">
        <div
          class="dialogGroup_left no_group"
          style="width: 100%;"
        >
          <div
            class="dialogGroup_right"
            style="width:100%"
          >
            <div class="Group_right_header">
              <div class="blue_header">
                <span>{{ $t('ifttt.selectGateway') }}</span>
              </div>
              <!-- <img class="refresh" :class="{ activeRefresh: isrefresh }" src="../../assets/img/refrsh.png" /> -->
              <button
                slot="next-step"
                class="up_step"
                @click="upstep"
              >
                {{ $t('ifttt.upStep') }}
              </button>
              <div class="ok_group">
                <button @click="firstSave">
                  {{ $t('ifttt.nextStep') }}
                </button>
              </div>
            </div>
            <div
              class="custom-tree-container"
              style="height: calc( 100% - 18px - 24px)"
            >
              <div class="ly-tree-container">
                <vuescroll>
                  <div class="wifi_tree">
                    <el-radio-group
                      v-for="(msg, index) in wifiData"
                      :key="'a' + index"
                      v-model="radio1"
                      class="wifi_tree_group"
                      style="height: max-content!important;"
                      @change="changegateway"
                    >
                      <el-radio
                        :label="msg"
                        :disabled="constIlluminationModel != null ? true : false"
                      >
                        <div
                          class="wifi_tree_body"
                          style="height: max-content; padding: 10px 0;"
                          :class="{checkCss:radio1 == msg}"
                        >
                          <div class="wifi_tree_child">
                            <img
                              class="card_img"
                              :src="getClassSkuImage(msg,'on','../../assets/img/d_f1.png')"
                            >
                            <!-- <template v-if="msg.IconUrl">
                                <img class="card_img" :src="'/static/device/icon/' + msg.IconUrl" />
                              </template>
                              <template v-else>
                                <img class="card_img" src="../../assets/img/d_f2.png" />
                              </template> -->
                            <br>
                            <span>{{ msg.DeviceName }}</span>
                          </div>
                        </div>
                      </el-radio>
                    </el-radio-group>
                  </div>
                </vuescroll>
              </div>
            </div>
            <!-- <div class="right_card_box" v-loading="loading" ref="video_area">
              <vuescroll>
                <el-row :gutter="20">
                  <div ref="video_area_context" style="overflow:auto">
                    <v-gatewaycard :registerList="[]" :isScrollRegist="false" :pageindex="1" :cardlist="wifiData" v-on:removeTree="removeTreeGateway" :is_check="true" :isradio="true"></v-gatewaycard>
                  </div>
                </el-row>
              </vuescroll>
            </div> -->
          </div>
        </div>
      </div>
    </template>
    <template v-if="LightStep == 1">
      <div class="dialogGroup_cont">
        <div class="dialogGroup_left no_group">
          <ly-tree
            :gpno="highid"
            :is_superuser="false"
            :area-tree-type="1"
            :showcount="true"
            :displaynoarea="true"
            :isrefresh="true"
            @treeClick="treeClick"
          />
          <!-- <ly-tree ref="mytree" :gpno="highid" :is_superuser="false" :areaTreeType="3" :showcount="true" :isrefresh="true" @treeClick="treeClick"></ly-tree> -->
          <!-- <div class="tree_content">
						<div class="tree_title">
							{{ $t('tree.title') }}
							<img class="refresh" :class="{ activeRefresh: isrefresh }" src="../../assets/img/refrsh.png" />
						</div>

						<div class="custom-tree-container">
							<div class="ly-tree-container">
								<vuescroll>
									<div class="wifi_tree">
										<el-radio-group v-model="radio1" @change="changegateway" v-for="(item, index) in wifiData" :key="'a' + index">
											<el-radio-button :label="item" :disabled="constIlluminationModel != null ? true : false">{{ item.DeviceName }}</el-radio-button>
										</el-radio-group>
									</div>
								</vuescroll>
							</div>
						</div>
					</div> -->
        </div>

        <!-- <div class="dialogGroup_right" style="width:100%"> -->
        <div class="dialogGroup_right">
          <div class="Group_right_header">
            <div class="blue_header">
              <span>{{ $t('deviceChoose.choose') }}</span>
            </div>

            <slot name="next-step" />

            <div class="ok_group">
              <button @click="selectGateway">
                {{ $t('ifttt.nextStep') }}
              </button>
            </div>
          </div>
          <div
            ref="video_areaSensor"
            class="right_card_box"
            style="width: 100%;"
          >
            <vuescroll>
              <div
                v-infinite-scroll="loadMoreSensor"
                class="card_box"
                :style="{ height: videoHeightSensor }"
                infinite-scroll-disabled="sensorIsdropdown"
                style="overflow:auto;"
                infinite-scroll-immediate="true"
                infinite-scroll-distance="10"
              >
                <!-- <v-card :registerList="registerList" :isScrollRegist="isScrollRegist" :cardlist="card_list2" :noclick="true" :is_check="true" :isradio="true" v-on:removeTree="removeTree"></v-card> -->
                <v-cardSensor
                  :cardlist="card_list2"
                  :noclick="true"
                  :is_check="true"
                  :isradio="true"
                  @removeTree="removeTree"
                />
              </div>
            </vuescroll>
          </div>
        </div>
      </div>
    </template>
    <template v-if="LightStep == 3">
      <div class="dialogGroup_cont">
        <v-choose
          ref="deviceSelect"
          :is_group="false"
          :areaid="areaid"
          :area-tree-type="1"
          :execute-type="2"
          :is-compare="true"
          :displaynoarea="true"
          :checkeddata="constIlluminationModel && constIlluminationModel['DeviceList']"
          :post-fun-param="getPostFunParam()"
          :confirm-name="$t('ifttt.nextStep')"
          :is-show-check="true"
          :is-group-save-bar="false"
          :is-group-control-bar="true"
          :group-control-title-name="$t('ifttt.light')"
          :group-control-name="$t('ifttt.groupControl')"
          :is-confirmc-calibrate="false"
          :is-illuminance="true"
          :is-occupied="true"
          :is-ifttt="true"
          :is-occupied-limit-group="true"
          :cur-rule-id="constIlluminationModel != null?constIlluminationModel['ConstIlluminationNo']:null"
          :is-cur-rule-group="(constIlluminationModel != null && constIlluminationModel['ConstIlluminationType']==0)?true:false"
          :post-fun-param-tree="radio1!=null?{gatewayVDeviceId:radio1.VDeviceId}:null"
          @confirm="confirm"
          @groupControlEvent="groupControlEvent"
          @changeGroupPost="changeGroupPost"
        >
          <!-- <button class="up_step" slot="next-step" @click="upstep" style="border: solid 1px #c6c6c6;background: transparent;color: unset;">{{ $t('ifttt.upStep') }}</button> -->
        </v-choose>
        <!-- <div class="dialogGroup_left no_group">
					<div class="tree_content">
						<div class="tree_title">
							{{ $t('tree.title') }}
							<img class="refresh" :class="{ activeRefresh: isrefresh }" src="../../assets/img/refrsh.png" />
						</div>

						<div class="custom-tree-container">
							<div class="ly-tree-container">
								<vuescroll>
									<div class="wifi_tree">
										<el-radio-group v-model="radio1" v-for="(item, index) in wifiData" :key="'a' + index">
											<el-radio-button :label="item" :disabled="true">{{ item.DeviceName }}</el-radio-button>
										</el-radio-group>
									</div>
								</vuescroll>
							</div>
						</div>
					</div>
				</div>

				<div class="dialogGroup_right" style="width:100%">
					<div class="Group_right_header">
						<div class="blue_header">
							<span>
								{{ $t('deviceChoose.choose') }} （
								<em>{{ card_list.length }}</em>
								）
							</span>
						</div>

						<button class="up_step" slot="next-step" @click="upstep">{{ $t('ifttt.upStep') }}</button>
            <div class="select_but" style="display: inline-flex; margin-right: 20px; margin-top: 6px;">
              <el-checkbox @change="checkAll" v-model="select">{{select?$t('scene.all'):$t('scene.allno')}}
              </el-checkbox>
            </div>
            <div class="ok_group">
							<template v-if="checkDevice.length > 0">
								<el-badge :value="checkDevice.length" class="item">
									<button @click="secondSave">{{ $t('deviceChoose.sure') }}</button>
								</el-badge>
							</template>
							<template v-else>
								<button @click="secondSave">{{ $t('deviceChoose.sure') }}</button>
							</template>
						</div>
					</div>
					<div class="right_card_box">
						<vuescroll>
							<div><v-cardtwo :cardlist="card_list" :noclick="true" :is_check="true" :isradio="false" v-on:removeTree="removeTreeDevice"></v-cardtwo></div>
						</vuescroll>
					</div>
				</div> -->
      </div>
    </template>
    <template v-if="LightStep == 4">
      <div
        class="constillumset_box"
      >
        <i
          class="el-icon-info"
          style="margin:0 8px"
        />
        {{ $t('ifttt.iftttSetTemplate') }}
      </div>
      <div class="height_set">
        <div class="requirement ">
          <div class="blue_border">
            {{ $t('ifttt.requirement') }}
          </div>
          <ul>
            <li>
              <em>(1)</em>
              {{ $t('ifttt.requirement01') }}
            </li>
            <li>
              <em>(2)</em>
              {{ $t('ifttt.requirement02') }}
            </li>
            <li>
              <em>(3)</em>
              {{ $t('ifttt.requirement03') }}
            </li>
            <li>
              <em>(4)</em>
              {{ $t('ifttt.requirement04') }}
            </li>
          </ul>
        </div>
        <div class="button_set">
          <button @click="upstep">
            {{ $t('ifttt.upStep') }}
          </button>
          <button
            class="fright blueButton"
            @click="nextstep"
          >
            {{ $t('ifttt.nextStep') }}
          </button>
        </div>
      </div>
    </template>
    <template v-else-if="LightStep == 5">
      <div
        class="light_lux"
        style="height:max-content;"
        @click.stop="leave"
        @mouseleave="leave"
      >
        <div class="clearfix">
          <div class="light_lux_middle">
            <div class="custom_base">
              <span>{{ $t('ifttt.constillumName') }}：</span>
              <input
                v-model="name"
                :placeholder="$t('ifttt.constillumNameTips')"
                maxlength="32"
              >
            </div>
            <div class="lux_tab_box">
              <div
                class="tab_header clearfix"
                style="text-align:left;"
              >
                <div style="display: inline-flex;margin-bottom: 5px;">
                  <div
                    class="header_tabset set1"
                    :class="{ header_current: modetype == 2 }"
                    @click="setLight(2)"
                  >
                    {{ $t('lastLight.open') }}
                  </div>
                  <div
                    class="header_tabset set2"
                    :class="{ header_current: modetype == 1 }"
                    @click="setLight(1)"
                  >
                    {{ $t('lastLight.close') }}
                  </div>
                </div>
              </div>
              <!-- <i class="icon-11"></i> -->
              <template v-if="modetype == 2">
                <span class="lux_span1 text-button">
                  <em
                    @mouseenter="enter"
                    @click.stop="enter"
                  >?</em>
                  {{ $t('ifttt.watch01') }}
                </span>
              </template>
              <div class="lux_num_group">
                <div class="lux_num">
                  <span><em>{{ sensorCorrection }}</em>（LUX）</span>
                  <span>{{ $t('ifttt.luxCorrectNum') }}</span>
                  <div class="sensorilluminanceImg" />
                </div>
                <div class="lux_num">
                  <span><em>{{ sensorilluminance }}</em>（LUX）</span>
                  <span>{{ $t('ifttt.luxNum') }}</span>
                  <div class="sensorCorrectionImg" />
                </div>
              </div>
              <div class="lux_tab_content">
                <div
                  v-if="modetype == 2"
                  class="lux_tab"
                  :class="{eventNone:(sensorIsCorrected == false || (sensorIsCorrected == undefined && sensorilluminance == sensorCorrection))}"
                  :style="(sensorIsCorrected == false || (sensorIsCorrected == undefined && sensorilluminance == sensorCorrection))?'opacity: 0.3;':''"
                >
                  <span
                    class="lux_span2"
                    style="padding-left: 36px;"
                  >{{ $t('lastLight.Illuminance') }} Min - Max (<em class="warmfont">1 - 3000</em>) {{ $t('ifttt.watch02') }}</span>
                  <div class="lux_line clearfix">
                    <div class="lux_left">
                      <em class="dot_num">1</em>
                      <div class="lux_set">
                        <span>
                          {{ $t('lastLight.Illuminance') }}(
                          <em>{{ $t('lastLight.lessthan') }}</em>
                          )
                        </span>
                        <el-input-number
                          v-model="lux_start"
                          class="line_input"
                          :min="0"
                        />
                      </div>
                    </div>
                    <!-- <div class="lux_slider_switch">
                      <span>{{ $t('sceneCard.lightSwitch') }}</span>
                      <el-switch
                        v-model="luxSwitchs.switch1"
                        active-color="#7dacee"
                        inactive-color="#d9e2f0"
                        :active-value="true"
                        :inactive-value="false"
                        @change="val => luxSwitchs.switch1 = val"
                      />
                    </div> -->
                    <div
                      v-if="luxSwitchs.switch1"
                      class="lux_slider_cont complete-line"
                    >
                      <span class="lux_span">{{ $t('lastLight.brightness') }}</span>
                      <i class="icon--97 icon_img" />
                      <div class="lux_slider">
                        <el-slider
                          v-model="smallslider"
                          :min="minLight"
                          :max="maxLight"
                          show-input
                        />
                      </div>
                    </div>
                    <div v-else class="lux_slider_cont complete-line" />
                  </div>
                  <div class="lux_line clearfix">
                    <div class="lux_left">
                      <em class="dot_num">2</em>
                      <div class="lux_set">
                        <span>
                          {{ $t('lastLight.Illuminance') }}(
                          <em>{{ $t('lastLight.range') }}</em>
                          )
                        </span>
                        <el-input-number
                          v-model="lux_one"
                          class="lux_input"
                          :min="0"
                        />
                        {{ $t('lastLight.to') }}
                        <el-input-number
                          v-model="lux_two"
                          class="lux_input"
                          :min="0"
                        />
                      </div>
                    </div>

                    <!-- <div class="lux_slider_switch">
                      <span>{{ $t('sceneCard.lightSwitch') }}</span>
                      <el-switch
                        v-model="luxSwitchs.switch2"
                        active-color="#7dacee"
                        inactive-color="#d9e2f0"
                        :active-value="true"
                        :inactive-value="false"
                        @change="val => luxSwitchs.switch2 = val"
                      />
                    </div> -->
                    <div
                      v-if="luxSwitchs.switch2"
                      class="lux_slider_cont complete-line"
                    >
                      <span class="lux_span">{{ $t('lastLight.brightness') }}</span>
                      <i class="icon--97 icon_img" />
                      <div class="lux_slider">
                        <el-slider
                          v-model="andslider"
                          :min="minLight"
                          :max="maxLight"
                          show-input
                        />
                      </div>
                    </div>
                    <div v-else class="lux_slider_cont complete-line" />
                  </div>
                  <div class="lux_line clearfix">
                    <div class="lux_left">
                      <em class="dot_num">3</em>
                      <div class="lux_set">
                        <span>
                          {{ $t('lastLight.Illuminance') }}(
                          <em>{{ $t('lastLight.big') }}</em>
                          )
                        </span>
                        <el-input-number
                          v-model="lux_end"
                          class="line_input"
                          :min="0"
                        />
                      </div>
                    </div>
                    <!-- <div class="lux_slider_switch">
                      <span>{{ $t('sceneCard.lightSwitch') }}</span>
                      <el-switch
                        v-model="luxSwitchs.switch3"
                        active-color="#7dacee"
                        inactive-color="#d9e2f0"
                        :active-value="true"
                        :inactive-value="false"
                        @change="val => luxSwitchs.switch3 = val"
                      />
                    </div> -->
                    
                    <div
                      v-if="luxSwitchs.switch3"
                      class="lux_slider_cont complete-line"
                    >
                      <span class="lux_span">{{ $t('lastLight.brightness') }}</span>
                      <i class="icon--97 icon_img" />
                      <div class="lux_slider">
                        <el-slider
                          v-model="bigslider"
                          :min="minLight"
                          :max="maxLight"
                          show-input
                        />
                      </div>
                    </div>
                    <div v-else class="lux_slider_cont complete-line" />
                  </div>
                </div>
                <div
                  v-if="modetype == 1"
                  class="lux_tab2"
                  :class="{eventNone:(sensorIsCorrected == false || (sensorIsCorrected == undefined && sensorilluminance == sensorCorrection))}"
                  :style="(sensorIsCorrected == false || (sensorIsCorrected == undefined && sensorilluminance == sensorCorrection))?'opacity: 0.3;':''"
                >
                  <div
                    class="lux_tab3"
                    style="background-color:unset;"
                  >
                    <div
                      v-show="false"
                      class="lux_slider_cont complete-line"
                    >
                      <span class="lux_span">{{ $t('lastLight.brightness') }}</span>
                      <i class="icon--97 icon_img" />
                      <div
                        class="lux_slider"
                        style="position: relative;"
                      >
                        <el-slider
                          v-model="lux_slider"
                          :min="minLight"
                          :max="maxLight"
                          show-input
                          @change="changeslider"
                        />
                        <span style="position: absolute;top: 10px;font-size: 12px;right: 5px;line-height: normal;">%</span>
                      </div>
                    </div>
                    <div class="lux_slider_cont">
                      <!-- <span class="lux_span">{{ $t('lastLight.brightness') }}</span>
                      <input v-model="customSensorValue" :placeholder="$t('ifttt.luxCorrectNum')"/>
                      <span class="lux_span">LUX</span> -->
                      <div
                        class="custom_base"
                        style="text-align: center;"
                        :class="(sensorIsCorrected == false || (sensorIsCorrected == undefined && sensorilluminance == sensorCorrection))?'eventNone':''"
                      >
                        <span>{{ $t('lastLight.Illuminance') }}：</span>
                        <el-input-number
                          v-model="customSensorValue"
                          :disabled="(sensorIsCorrected == false || (sensorIsCorrected == undefined && sensorilluminance == sensorCorrection))"
                          class="line_input"
                          :min="1"
                          :max="3000"
                        />LUX
                      </div>
                    </div>
                    <!-- <p style="text-align:center;">
                      <el-checkbox
                        v-model="constantIlluminanceValue"
                        class="limited_checkbox"
                      />
                      {{ $t('ifttt.constantIlluminanceTip') }}
                    </p> -->
                  </div>
                </div>
                <div
                  v-if="(sensorIsCorrected == false || (sensorIsCorrected == undefined && sensorilluminance == sensorCorrection))"
                  class=" warmfont lastLight_info"
                >
                  {{ $t('ifttt.sensorCorrectionTips') }}
                </div>
              </div>
              <div
                v-if="seen"
                class="lux_table"
                @mouseleave="leave"
              >
                <div class="lux_table_title">
                  {{ $t('lastLight.standard') }}
                </div>
                <el-table
                  class="light_table"
                  :data="tableData"
                  border
                  style="width: 100%;"
                  height="300"
                  :row-style="{height:'20px'}"
                >
                  <el-table-column :label="$t('ifttt.address')">
                    <template slot-scope="scope">
                      {{ $t(scope.row.address) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="standard"
                    :label="$t('ifttt.standard')"
                    width="338"
                  />
                </el-table>
              </div>
            </div>
          </div>
          <!-- <div class="lastLight_info">{{ $t('lastLight.warning') }}</div> -->
        </div>

        <div class="button_set clearfix">
          <el-button @click="upstep">
            {{ $t('ifttt.upStep') }}
          </el-button>
          <el-button
            :class="{eventNone:(sensorIsCorrected == false || (sensorIsCorrected == undefined && sensorilluminance == sensorCorrection))}"
            :style="(sensorIsCorrected == false || (sensorIsCorrected == undefined && sensorilluminance == sensorCorrection))?'opacity: 0.3;':''"
            :disabled="(sensorIsCorrected == false || (sensorIsCorrected == undefined && sensorilluminance == sensorCorrection))"
            :loading="loading"
            class=" lightsetOk"
            @click="LightStepOK"
          >
            {{ $t('ifttt.yes') }}
          </el-button>
          <!-- <el-checkbox class="card_check" v-model="isGroupPost" :disabled="isGroupPostDisabled" v-if="wifiData.length==1" style="margin: 10px 5px 10px 50px;">{{ $t('ifttt.groupControl') }}</el-checkbox> -->
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import vuescroll from 'vuescroll'
import vChoose from '@/components/common/deviceChoose.vue'
// import vCard from '@/components/common/card.vue';
import vCardSensor from '@/components/common/cardtwoSmall.vue'
import { FindGatewayList, AdjustBright } from '@/axios/IArea.js'
import { Create, Edit, Find } from '@/axios/IConstIllumination.js'
import { FindIlluminanceSensorList, FindDeviceListByPage, FindDevice, CallAction, FindActionAbility, FindSimpleDeviceListByPage } from '@/axios/IDevice.js'
import { alerterror, alertsuccess, warning ,info} from '@/assets/js/common.js'
import { postWebIOSocket } from '@assets/socket'
export default {
  components: {
    vCardSensor,
    vuescroll,
    vChoose
    // vCard,
    // vCardtwo,

  },
  props: {
    gpNo: {
      type: Number,
      default: -1 // 区域id
    },
    constantid: {
      type: Number,
      default: -1 // 恒照度id
    }
  },
  data () {
    return {
      areaid: -1,
      name: this.$t('iftttset.illumination'),
      LightStep: 1, // 到第几步
      is_device: false, // 是否设备
      cardNum: true, // 未使用
      allcardNum: 0, // 设备数量
      okCheckNum: 0, // 选中设备数
      is_step: true, // 未使用
      isrefresh: false, // 是否刷新
      selectMore: true, // 未使用
      is_check: true, // 是否多选
      lux_slider: 0, // 亮度
      minLight: this.$store.state.staticConfig.AbilityConfig.DefaultValue.Daylight['0x03130000'].Value.minValue, // 亮度最小值
      maxLight: 100, // 亮度最大值
      constantIlluminanceValue: false,
      luxSwitchs: {
        switch1: true,
        switch2: true,
        switch3: true
      },
      tableData: [
        {
          address: 'ifttt.addressText1',
          standard: '100'
        },
        {
          address: 'ifttt.addressText2',
          standard: '300'
        },
        {
          address: 'ifttt.addressText3',
          standard: '150'
        },
        {
          address: 'ifttt.addressText4',
          standard: '300'
        },
        {
          address: 'ifttt.addressText5',

          standard: '300'
        },
        {
          address: 'ifttt.addressText6',

          standard: '300'
        },
        {
          address: 'ifttt.addressText7',

          standard: '200'
        },
        {
          address: 'ifttt.addressText8',

          standard: '300'
        },
        {
          address: 'ifttt.addressText9',

          standard: '500'
        },
        {
          address: 'ifttt.addressText10',

          standard: '50'
        },
        {
          address: 'ifttt.addressText11',
          standard: '200'
        }
      ],
      radio1: null, // 绑定选中的网关
      wifiData: [], // 网关对象
      cardlist3: [], // 未使用
      card_list2: [], // 传感器集合
      tempsensormodel: null, // 点击选择的传感器对象 临时
      sensormodel: null, // 选择的传感器对象
      card_list: [], // 设备集合
      checkDevice: [], // 选中的设备集合
      gatewaymodel: null, // 选择的网关对象
      modetype: 1, // 1闭环设置 2开环设置
      constIlluminationtype: 1, // 0区孔 1设备控
      refresh: false, // 控制step1刷新
      brightlevel: 0, // 未使用
      constIlluminationModel: null, // 恒照度对象
      seen: false, // 是否显示描述
      lux_start: '', // 照度小于
      lux_end: '', // 照度大于
      lux_one: '', // 范围1
      lux_two: '', // 范围2
      smallslider: 0, // 开环亮度 小于
      andslider: 0, // 开环亮度 范围
      bigslider: 0, // 开环亮度 大于
      loading: false, // 是否加载
      sensorilluminance: 0, // 传感器读数
      sensorCorrection: 0, // 传感器校准读数
      responsecount: 0, // 下发响应次数
      registerList: [], // 注册的设备
      isScrollRegist: false, // 是否滚动过
      isGroupPost: false,
      isGroupPostDisabled: false,
      select: false, // 全选按钮
      highid: -1, // 区域id
      sensorIndex: 1, // 传感器翻页标记
      sensorPageSize: 30, // this.$store.state.pageTotalLimit, //每页显示数量
      sensordropdownloading: false, // 下拉等待条
      sensorIsdropdown: true, // 默认禁用下拉
      videoHeightSensor: 0, // 滚动区域高度
      customSensorValue: undefined
    }
  },
  computed: {
    socketmodel () {
      return this.$store.state.socketmodel　　// 需要监听的数据
    }
  },
  watch: {
    socketmodel (rs) {
      this.functionScoketsync_info_event(rs)
    }
  },
  destroyed () {
    // 离开页面执行
    this.initsocket()
    // this.removehighid();
  },
  created () {
    this.areaid = this.gpNo
    this.initsocket()
    this.allCard()
  },
  mounted () {
    this.areaid = this.gpNo
    // if (this.areaid != -1) {
    this.dofindination()

    // }
  },
  methods: {
    /* 下拉加载数据分页
     */
    loadMoreSensor () {
      this.sensorIndex = this.sensorIndex + 1
      this.doFindIlluminanceSensorList()
    },
    /* 获得滚动页面高度
     */
    getVideoHeightSensor () {
      if (this.$refs.video_areaSensor != null) { this.videoHeightSensor = this.$refs.video_areaSensor.offsetHeight + 'px' }
    },
    /* 点击树
    */
    treeClick (val) {
      this.sensormodel = null
      this.highid = val[0].id

      // this.isshowing();
      // this.init("default");
      // this.doFindList();

      // this.initsocket();
      this.initSensor('default')
      this.doFindIlluminanceSensorList()
    },

    /* 初始化数据
    */
    initSensor (param) {
      if (param == 'default') {
        this.card_list2 = []
        this.sensorIndex = 1
      }
      this.sensordropdownloading = false
      this.sensorIsdropdown = true
    },
    groupControlEvent(event) {
      this.$refs.deviceSelect.groupEventNone(event);
      if (event == true) { this.$refs.deviceSelect.checkAll(false); }
      if (event) { warning(this, this.$t('ifttt.groupControlTip')); }
      this.$nextTick(()=>{
        this.isGroupPost = event;
        this.$refs.deviceSelect.setGroupControlValue(this.isGroupPost);
      })

    },
    selectGateway () {
      if (this.sensormodel == null) {
        warning(this, this.$t('lastLight.selectwaring'))
        return
      }
      // if(this.verifyGateway()){
      this.LightStep = 2

      setTimeout(param => {
        this.getVideoHeightSensor()
        this.initSensor('default')
        this.doFindIlluminanceSensorList()
      }, 500)
      // }
    },
    /* 开环闭环切换
    */
    setLight (val) {
      if (this.constIlluminationModel == null) {
        this.modetype = val
      } else {
        warning(this, this.$t('ifttt.nowarn'))
      }
    },
    /* 统一控制 接口数据返回方法
    * rs 接口返回数据包
    */
    functionAdjustBrightEvent (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /* 调节亮度下发设备
    */
    changeslider () {
      if (this.isGroupPost == true) {
        // 下发设备-网关
        // this.doAdjustBright([this.radio1 ]);
        // 调节亮度
        if (this.radio1 != null) {
          let para = { gpNo: this.areaid, bright: Math.floor(this.lux_slider * 255 / 100), vGatewayDeviceId: this.radio1.VDeviceId }
          AdjustBright(para, this.functionAdjustBrightEvent)
          para = null
        }
      } else {
        // 下发设备
        if (this.checkDevice.length > 0) {
          this.doAdjustBright()
        }
      }
    },
    /* 调节亮度下发设备
    */
    doAdjustBright (item) {
      // 下发指令
      // console.log(this.checkDevice);
      const _device = item || this.checkDevice
      if (_device != null) {
        _device.forEach(n => {
          let para = {
            vDeviceId: n.VDeviceId,
            classSku: n.ClassSku,
            ChildId: n.ChildId
          }
          FindActionAbility(para, this.functionDoFindActionAbility)
          para = null
        })
      }
      // console.log(para);
      // AdjustBright(para,this.functionDoAdjustBright);
      // para=null;
      // _idlist=null;
    },
    /* 根据设备的能力 来进行下发指令
    * rs：上一个方法返回的数据包
    * para：下发参数
    */
    functionDoFindActionAbility (rs, para) {
      // console.log(rs);
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null) {
          if (rs.Result.ActionList.length > 0) {
            rs.Result.ActionList.forEach(n => {
              n.Values.forEach(m => {
                if (m.Type != null) {
                  if (m.Type.indexOf('0x03') != -1) {
                    // this.$store.dispatch('changeLoading', true);
                    this.doCallAction(n, para)
                  }
                }
              })
            })
          }
        }
      }
    },
    /* 下发的方法
    * item：action对象
    * model：设备对象
    */
    doCallAction (item, model) {
      let _values
      // console.log(item);
      if (item.MsgType.indexOf('0x03A60000_') != -1) {
        const _childid = item.MsgType.substr(item.MsgType.length - 1, 1)
        // _values =_childid+","+item.Values[0].DefaultValue;
        _values = _childid + ','
        if (item.Values[0] != null && item.Values[0].DefaultValue != null) {
          _values += this.rhythmlLightInforValueSubmit(item.Values[0].DefaultValue)
        }
      } else {
        item.Values.forEach(tem => {
          let _defaultvalue = ''
          if (tem.Type != null) {
            if (tem.Type.indexOf('0x03') != -1) {
              _defaultvalue = this.rhythmlLightInforValueSubmit(this.lux_slider)
            } else {
              // _defaultvalue=tem.DefaultValue+'';
              if (tem.DefaultValue != null) {
                _defaultvalue = this.rhythmlLightInforValueSubmit(tem.DefaultValue) + ''
              }
            }
          } else {
            // _defaultvalue=tem.DefaultValue+'';
            if (tem.DefaultValue != null) {
              _defaultvalue = this.rhythmlLightInforValueSubmit(tem.DefaultValue) + ''
            }
          }

          if (_values == null) {
            _values = _defaultvalue
          } else {
            _values += ',' + _defaultvalue
          }
        })
      }
      let para = { vDeviceId: model.vDeviceId, msgType: item.MsgType, channelId: model.ChildId, values: _values }
      CallAction(para, this.functionDoCallAction)
      para = null
      _values = null
    },
    doCallActionLight (item) {
      // var para = { vDeviceId: this.model.VDeviceId, msgType: "0x03130000", channelId: this.model.ChildId, values: _values };
      // CallAction(para, this.functionDoCallAction);
      // para = null;
    },
    /* 下发的方法 接口返回 数据处理
    * rs：接口返回数据包
    */
    functionDoCallAction (rs) {
      this.responsecount++
      if (this.responsecount == this.checkDevice.length) {
        this.$store.dispatch('changeLoading', false)
        alertsuccess(this, this.$store.state.rightStatusCode)
        this.responsecount = 0
      }
    },
    /* 暂时未使用
    */
    functionDoAdjustBright (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /* 推送过来的传感器度数
    * rs:推送过来的数据包
    */
    functionScoketsync_info_event (rs) {
      // console.log(rs);

      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result) {
          if (rs.Result[0].Type == 11) {
            if (this.sensormodel != null) {
              if (this.sensormodel.VDeviceId == rs.Result[0].VDeviceId) {
                rs.Result[0].StatusInfo.forEach(n => {
                  if (n.StatusType == '0x0600') {
                    this.getilluminationValue(n)
                    // if(n.MessageType=="0x05090000"){

                    if (n.Value != null && n.Value != "--") { this.sensorilluminance = Number(n.Value); }
                    if (n.illumination != null && n.illumination != "--") { this.sensorCorrection = Number(n.illumination); }
                    this.sensorIsCorrected = n["IsCorrected"];
                  } else if (n.StatusType == "0x0700") {
                    this.gettemperatureValue(n);
                  } else if (n.StatusType == "0x1600" || n.StatusType == "0x1601") {//上电时长/开灯时长 界面将秒转成小时
                    this.getpowertimeValue(n);
                  }
                })
              }
            }
          }
        }
      }
    },
    /* 显示描述
    */
    enter () {
      this.seen = true
    },
    /* 隐藏描述
    */
    leave () {
      this.seen = false
    },
    /* 改变步骤数
    */
    stepchange(_step, isCheck) {

      if (isCheck != true && _step > 2 && !this.verifyGateway()) {
        return
      }
      if (_step > 1 && this.sensormodel == null) {
        warning(this, this.$t('lastLight.selectwaring'))
        return
      }
      if (_step == 3) {
        this.goStep3()
      } else if (_step == 5) {
        this.LightStep = _step
        this.dosocket()
      } else {
        this.LightStep = _step
        if (_step == 1) {
          setTimeout(param => {
            this.getVideoHeightSensor()
            this.initSensor('default')
            this.doFindIlluminanceSensorList()
          }, 500)
        }
      }

      // this.LightStep=_step;
    },
    /* 查询该区域下是否有恒照度
    */
    dofindination () {
      // 查询该区域下是否有恒照度
      // if (this.areaid != -1) {
      if (this.constantid != -1 && this.constantid != null) {
        let para = { gpNo: this.areaid, constIlluminationNo: this.constantid }
        Find(para, this.functionDoFind)
        para = null
      } else {
        let _param = this.$store.state.areasGpName[this.areaid]
        _param = _param && _param.GpName + '.'
        this.name = _param + this.$t('iftttset.illumination')
        _param = null
        this.doFindGatewayList()

        // this.initsocket();
        // this.doFindIlluminanceSensorList();
        this.stepchange(1)
      }
      // }
    },
    /* 初始值设置
    */
    getSegmentlist () {
      if (this.modetype == 2) {
        // 开环赋值
        this.constIlluminationModel.SegmentList.forEach(n => {
          if (n.MinSensorValue == 0) {
            this.lux_start = n.MaxSensorValue
            this.smallslider = this.rhythmlLightInforValue(Number(n.BrightLevel))
          } else if (n.MaxSensorValue == 3000) {
            this.lux_end = n.MinSensorValue
            this.bigslider = this.rhythmlLightInforValue(Number(n.BrightLevel))
          } else {
            this.lux_one = n.MinSensorValue
            this.lux_two = n.MaxSensorValue
            this.andslider = this.rhythmlLightInforValue(Number(n.BrightLevel))
          }
        })
      } else {
        // 闭环赋值
        // console.log(this.constIlluminationModel);
        // this.sensorilluminance=this.constIlluminationModel.SegmentList[0].MinSensorValue;
        this.lux_slider = this.rhythmlLightInforValue(Number(this.constIlluminationModel.SegmentList[0].BrightLevel))
      }
    },
    /* 查询当前区域下是否有恒照度 接口返回处理 查询网关跟设备
    * rs:接口返回的数据包
    */
    functionDoFind (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null) {
          this.constIlluminationModel = rs.Result;
          if (this.constIlluminationModel.ConstIlluminationName != null) { this.name = this.constIlluminationModel.ConstIlluminationName; }
          if (this.constIlluminationModel.ConstIlluminationType == 1 && this.constIlluminationModel && this.constIlluminationModel['DeviceList']) { this.checkDevice = this.constIlluminationModel['DeviceList']; }

          if (this.constIlluminationModel["SegmentList"] != null && this.constIlluminationModel["SegmentList"].length == 1) { this.customSensorValue = this.constIlluminationModel["SegmentList"][0]["MaxSensorValue"] };
          this.modetype = this.constIlluminationModel.Mode;
          this.isGroupPost = this.constIlluminationModel.ConstIlluminationType == 0;

          if (this.constIlluminationModel.SegmentList != null && this.constIlluminationModel.SegmentList.length == 1) { this.customSensorValue = this.constIlluminationModel.SegmentList[0].MaxSensorValue };
          this.modetype = this.constIlluminationModel.Mode
          this.isGroupPost = this.constIlluminationModel.ConstIlluminationType == 0

          this.areaid = this.constIlluminationModel.GpNo
          this.getSegmentlist()

          this.doGetWayGate(this.constIlluminationModel.TriggerList[0].VDeviceId, 0)
        }
        this.doFindGatewayList()

        // this.initsocket();
        // this.doFindIlluminanceSensorList();
        this.stepchange(1)
      }
    },
    /* 设备卡点击选中事件
    * list:已选设备
    */
    removeTree (list) {
      // 选中传感器返回事件
      // 单选把所有选中的取消选中
      list[0].forEach(item => {
        if (item.VDeviceId != list[1].VDeviceId) {
          item.ischecked = false
        } else if (item.ChildId != list[1].ChildId) {
            item.ischecked = false
          }
      })

      this.card_list2 = list[0]
      this.getCheckedData()
    },
    /* 获得选择设备
    * list:已选设备
    */
    removeTreeDevice (list) {
      // 选中的设备
      this.card_list = list[0]
      this.getCheckedDataDevice()
    },
    /* 将选中的设备 放入checkDevice对象
    */
    getCheckedDataDevice () {
      let _arry = []
      this.card_list.forEach(item => {
        if (item.ischecked) {
          _arry.push(item)
        }
      })
      this.checkDevice = _arry
      _arry = null

      if (this.checkDevice.length == this.getCardTolal()) {
        this.select = true
      } else {
        this.select = false
      }
    },
    getCardTolal () {
      let num = 0
      this.card_list.forEach(item => {
        if (item.hidden != true) {
          num++
        }
      })
      return num
    },
    /* 获得选择的传感器对象数据
    */
    getCheckedData () {
      // 获得选择的传感器对象数据
      this.card_list2.forEach(item => {
        if (item.ischecked) {
          this.tempsensormodel = item
          this.sensormodel = item
        }
      })
    },
    /* 数据初始化
    */
    initdata () {
      this.radio1 = null
      this.tempsensormodel = null
      this.sensormodel = null
    },
    /* socket初始化
    */
    initsocket () {
      postWebIOSocket('sync_info_removeall_event')
      this.$store.dispatch('changeIsregisterSocket', true)
    },
    /* 获得网关
    */
    changegateway () {
      // 获得网关
      // this.tempsensormodel = null;
      // this.sensormodel = null;
      // this.checkDevice = [];
    },
    /* 获得照度传感器
    */
    doFindIlluminanceSensorList () {
      if (this.sensorIndex > 1) {
        this.sensordropdownloading = true
      }
      // 获得照度传感器
      this.sensorIsdropdown = true
      // if(this.radio1){
      // 	var para = { gpNo: this.areaid, gatewayVDeviceId: this.radio1.VDeviceId };
      // 	this.refresh = false;
      // 	this.card_list2 = [];
      // 	FindIlluminanceSensorList(para, this.functionDoFindIlluminanceSensorList);
      // 	para = null;
      // }

      // 获得对应设备
      let para = {
        gpNo: this.highid,
        gpNos: this.highid,
        pageIndex: this.sensorIndex,
        pageSize: this.sensorPageSize,
        extendDeviceTypes: 16,
        childCategoryType: 128,
      };
      FindDeviceListByPage(para, this.functionDoFindIlluminanceSensorList);
      para = null;

    },
    /* 获得照度传感器 接口返回处理
    * rs ；接口返回的数据包
    */
    functionDoFindIlluminanceSensorList(rs) {
      this.initSensor();

      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null && rs.Result.RecordList != null && rs.Result.RecordList.length > 0) {
          this.sortResult('device', rs.Result, 'RecordList')
          let _obj, _sensorilluminance
          rs.Result.RecordList.forEach(item => {
            item.flag = false // 是否可编辑
            item.ischecked = false // 是否默认选中
            item.isflicker = false // 是否闪烁
            item.isdisabled = false // 是否显示
            item.iseventNone = true // 是否禁用

            if (item.StatusInfo != null && item.StatusInfo != '') {
              item.StatusInfo = JSON.parse(item.StatusInfo)
            } else {
              item.StatusInfo = []
            }
            if (item.StatusInfo != null && item.StatusInfo.length > 0) {
              _obj = item.StatusInfo.find(param => {
                return param.StatusType.indexOf('0x06') >= 0
              })
              if (_obj != null) {
                item.iseventNone = false
                this.getilluminationValue(_obj)
              }
            }

            if (this.sensormodel != null) {
              if (_obj != null && item.VDeviceId == this.sensormodel.VDeviceId) {
                item.ischecked = true;

                if (_obj.Value != null && _obj.Value != "--") { this.sensorilluminance = Number(_obj.Value); }
                if (_obj.illumination != null && _obj.illumination != "--") { this.sensorCorrection = Number(_obj.illumination); }
                this.sensorIsCorrected = _obj["IsCorrected"];
              }
            }

            // _arr.push(item);
            this.card_list2.push(item)
          })
          // } else {
          // 	this.card_list2 = [];
          _obj = null
          _sensorilluminance = null
        }
      }

      // this.refresh = true;
      // this.getCheckDevice();
      // this.addlist(this.card_list2);
      if (this.card_list2.length > 0 && this.card_list2.length < rs.Result.TotalCount) {
        this.sensorIsdropdown = false
      }
    },
    /* 未使用
    */
    addlist (list) {
      this.cardlist3 = []
      list.forEach(n => {
        this.cardlist3.push(n)
      })
    },
    /* 获得设备
    * _vid 设备号
    * _type 类型
    */
    doGetWayGate (_vid, _type) {
      let para = { vDeviceId: _vid, ptype: _type }
      FindDevice(para, this.functionDoFindDevice)
      para = null
    },
    /* 获得设备 接口返回处理  如果ptype==0 说明是编辑 通过父id来获得设备网关 如果不为0 说明是新增查询传感器
    * rs 接口返回的数据包
    * para 上个页面提交的参数
    */
    functionDoFindDevice (rs, para) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (para.ptype == 0) {
          this.tempsensormodel = rs.Result // 获得传感器对象
          this.sensormodel = rs.Result
          if (this.sensormodel != null) {
            var _obj = this.sensormodel.StatusInfo;
            if (typeof _obj == "string" && JSON.isJSON(_obj)) { this.sensormodel.StatusInfo = JSON.parse(this.sensormodel.StatusInfo); }
            _obj = this.sensormodel.StatusInfo;

            if (_obj != null && _obj.length > 0) {
              _obj = _obj.find(param => {
                return param["StatusType"].indexOf("0x06") >= 0;
              });

              if (_obj != null) {
                this.getilluminationValue(_obj)
                if (_obj.Value != null && _obj.Value != '--') { this.sensorilluminance = Number(_obj.Value) }
                if (_obj.illumination != null && _obj.illumination != '--') { this.sensorCorrection = Number(_obj.illumination) }
                this.sensorIsCorrected = _obj.IsCorrected
              }
            }
            _obj = null
            this.stepchange(5, true)
          }
        } else {
          if (this.wifiData.length > 0) {
            this.wifiData.forEach(n => {
              if (n.VDeviceId == rs.Result.VDeviceId) {
                this.radio1 = n

                // this.doFindIlluminanceSensorList();
              }
            })
          }
          // this.radio1=rs.Result;
        }

        // 去获得网关对象
      }
    },
    /* 获得网关 接口返回处理  如果是新增查询获得所有网关 默认选择第一个
    * rs 接口返回的数据包
    */
    functionDoFindGatewayList (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.wifiData = (rs.Result || []).filter(item => item.ClassSku !== '0x19070001');
        if (this.wifiData != null && this.wifiData.length > 0) {
          if (this.constIlluminationModel != null) {
            if (this.isGroupPost == true) {
              if (this.constIlluminationModel.DeviceList.length > 0) {
                var _curObj = this.constIlluminationModel.DeviceList[0]

                this.radio1 = this.wifiData.find(item => { return item.VDeviceId == _curObj.VDeviceId })
                _curObj = null
              }
            } else if (this.constIlluminationModel.DeviceList.length > 0) {
                var _curObj = this.constIlluminationModel.DeviceList[0]
                this.radio1 = this.wifiData.find(item => { return item.VDeviceId == _curObj.ParentVDeviceId })
                _curObj = null
              }
            // this.doGetWayGate(this.constIlluminationModel.TriggerList[0].VDeviceId, 0);
          } else {
            this.radio1 = this.wifiData[0]
            this.changegateway()
          }
        }
      }
      // console.log(rs);
    },
    /* 已经选择的设备 编辑模式下
    */
    // getCheckDevice() {
    // 	var para = {
    // 		gpNo: this.areaid,
    // 		pageIndex: 1,
    // 		pageSize: 2000,
    // 		deviceType: 2,
    // 		gatewayVDeviceId: this.radio1.VDeviceId
    // 	};
    // 	FindDeviceListByPage(para, this.functionDoFindDeviceListByPageToCheck);
    // 	para = null;
    // },
    /* 已经选择的设备 编辑模式下 接口返回的数据处理 直接跳到最后一步
    * rs:接口返回数据包
    */
    // functionDoFindDeviceListByPageToCheck(rs) {
    // 	if (rs.StatusCode == this.$store.state.rightStatusCode) {
    // 		if(rs.Result != null && rs.Result.RecordList != null) {
    //       this.sortResult("device", rs.Result,"RecordList");
    //
    // 			rs.Result.RecordList.forEach(item => {
    // 				if(this.constIlluminationModel!=null){
    // 					this.constIlluminationModel.DeviceList.forEach(m => {
    // 						if (item.VDeviceId == m.VDeviceId && item.ChildId == m.ChannelId) {
    // 							item.flag = false; //是否可编辑
    // 							item.ischecked = false; //是否默认选中
    // 							item.isflicker = false; //是否闪烁
    // 							item.isdisabled = false; //是否禁用

    // 							if (item.StatusInfo) {
    // 								if (item.StatusInfo != null && item.StatusInfo != '') {
    // 									item.StatusInfo = JSON.parse(item.StatusInfo);
    // 								} else {
    // 									item.StatusInfo = [];
    // 								}
    // 							}
    // 							this.checkDevice.push(item);
    // 						}
    // 					});
    // 					this.LightStep=5;
    // 				}

    // 			});
    // 		}
    // 	}

    // 	console.log(this.checkDevice);
    // },
    /* 获得网关
    */
    doFindGatewayList () {
      // 获得网关
      let para = { gpNo: this.areaid }
      FindGatewayList(para, this.functionDoFindGatewayList)
      para = null
    },
    getPostFunParam () {
      const param = {
        _gpNo: this.areaid,
        pageIndex: 1,
        pageSize: this.$store.state.pageTotalLimit,
        // deviceType: 2,
        childCategoryType: 2,
        gatewayVDeviceId: this.radio1.VDeviceId
      }
      if (this.constIlluminationModel != null && this.constIlluminationModel.ConstIlluminationNo != null) {
        param.constIlluminationNo = this.constIlluminationModel.ConstIlluminationNo
      }
      return param
    },
    /* 获得对应传感器的设备
    */
    doFindDeviceListByPage () {
      // 获得对应设备
      // var para = {
      // 	gpNo: this.areaid,
      // 	pageIndex: 1,
      // 	pageSize: 2000,
      // 	deviceType: 2,
      // 	gatewayVDeviceId: this.radio1.VDeviceId
      // };
      // FindDeviceListByPage(para, this.functionDoFindDeviceListByPage);
      // para = null;

      this.LightStep = 3

      // var refObj = this.$refs;
      // refObj = refObj && refObj.deviceSelect;
      // if(refObj != null){
      //   refObj.card_list2 = [];
      //   setTimeout(param => {
      //     this.$refs.deviceSelect.refresh();
      //   }, 100);
      // }
      // refObj = null;
    },
    /* 获得对应传感器的设备 接口返回数据处理
    * rs ： 接口返回数据包
    */
    // functionDoFindDeviceListByPage(rs) {
    // 	this.card_list = [];
    // 	if (rs.StatusCode == this.$store.state.rightStatusCode) {
    // 		if(rs.Result != null && rs.Result.RecordList != null) {
    // 			rs.Result.RecordList.forEach(item => {
    // 				item.flag = false; //是否可编辑
    // 				item.ischecked = false; //是否默认选中
    // 				item.isflicker = false; //是否闪烁
    // 				item.isdisabled = false; //是否禁用

    // 				if (item.StatusInfo) {
    // 					if (item.StatusInfo != null && item.StatusInfo != '') {
    // 						item.StatusInfo = JSON.parse(item.StatusInfo);
    // 					} else {
    // 						item.StatusInfo = [];
    // 					}
    // 				}
    // 				this.card_list.push(item);
    // 			});
    // 		} else {
    // 			this.card_list = [];
    // 			this.checkDevice = [];
    // 		}
    // 	} else {
    // 		this.card_list = [];
    // 		this.checkDevice = [];
    // 	}
    // 	if (this.checkDevice.length > 0) {
    // 		this.card_list.forEach(n => {
    // 			this.checkDevice.forEach(m => {
    // 				if (n.VDeviceId == m.VDeviceId && n.ChildId == m.ChildId) {
    // 					n.ischecked = true;
    // 				}
    // 			});
    // 		});
    // 	}
    // 	this.$store.dispatch('changeIsregisterSocket', true);
    // 	this.LightStep = 3;
    // },
    /* 获得设备数量
    */
    allCard () {
      this.allcardNum = this.card_list2.length
    },
    confirm (val) {
      this.removeTreeDevice([val])
      this.secondSave()
    },
    /* 点击下一步
    */
    // confirm() {
    // 	console.log('confirm');
    // 	if (this.LightStep < 5) {
    // 		this.LightStep = this.LightStep + 1;
    // 	} else {
    // 		this.LightStep = 5;
    // 	}
    // },
    /* 点击上一步
    */
    upstep () {
      if (this.LightStep > 1) {
        if (this.LightStep == 4) {
          this.goStep3()
        } else {
          this.LightStep -= 1
        }
      } else {
        this.LightStep = 1
      }
    },
    /* 点击上一步
    */
    nextstep () {
      if (this.LightStep < 5) {
        this.LightStep = this.LightStep + 1
      } else {
        this.LightStep = 5
        this.dosocket()
      }
    },
    /* 执行添加恒照度
    */
    doCreate() {

      //添加恒照度

      var SegmentList = [];
      if (this.sensormodel == null) {
        warning(this, this.$t('lastLight.selectwaring'))
        return
      }
      if (this.checkDevice.length == 0 && this.isGroupPost == false) {
        warning(this, this.$t('lastLight.selectwaring2'))
        return
      }
      if (this.modetype == 1) {
        // 闭环
        let _SegmentList = {
          MaxSensorValue: this.sensorilluminance || 0,
          MinSensorValue: this.sensorilluminance || 0,
          BrightLevel: this.rhythmlLightInforValueSubmit(this.lux_slider),
          DevType: 1,
          Opendegree: 0,
          Degree: 0
        }
        if (this.sensorIsCorrected) { // 是否校准
          // if(this.sensorilluminance != this.sensorCorrection){ //是否校准
          if (this.customSensorValue == undefined || this.customSensorValue == '') {
            _SegmentList.MaxSensorValue = this.sensorCorrection
            _SegmentList.MinSensorValue = this.sensorCorrection
          } else {
            _SegmentList.MaxSensorValue = this.customSensorValue
            _SegmentList.MinSensorValue = this.customSensorValue
          }
        }
        SegmentList.push(_SegmentList)
        _SegmentList = null
      } else if (this.modetype == 2) {
        // 开环
        if (this.lux_start == 0 || this.lux_one == 0 || this.lux_two == 0 || this.lux_end == 0) {
          warning(this, this.$t('lastLight.selectwaring3'))
          return
        }
        if (this.lux_end > 3000 || this.lux_start > 3000 || this.lux_one > 3000 || this.lux_two > 3000 ||
          this.lux_end <= 0 || this.lux_start <= 0 || this.lux_one <= 0 || this.lux_two <= 0) {
          warning(this, this.$t('lastLight.Illuminance') + 'Min - Max ( 1 - 3000 )')
          return
        } else if (this.lux_start > this.lux_one) {
          warning(this, this.$t('lastLight.selectwaring4'))
          return
        } else if (this.lux_one > this.lux_two) {
          warning(this, this.$t('lastLight.selectwaring5'))
          return
        } else if (this.lux_two > this.lux_end) {
          warning(this, this.$t('lastLight.selectwaring6'))
          return
        }
        const _modelsmall = {
          MaxSensorValue: this.lux_start,
          MinSensorValue: 0,
          BrightLevel: this.rhythmlLightInforValueSubmit(this.smallslider),
          DevType: 1,
          Opendegree: 0,
          Degree: 0
        }

        const _modeland = {
          MaxSensorValue: this.lux_two,
          MinSensorValue: this.lux_one,
          BrightLevel: this.rhythmlLightInforValueSubmit(this.andslider),
          DevType: 1,
          Opendegree: 0,
          Degree: 0
        }

        const _modelbig = {
          MaxSensorValue: 3000,
          MinSensorValue: this.lux_end,
          BrightLevel: this.rhythmlLightInforValueSubmit(this.bigslider),
          DevType: 1,
          Opendegree: 0,
          Degree: 0
        }
        SegmentList.push(_modelsmall)
        SegmentList.push(_modeland)
        SegmentList.push(_modelbig)
      }

      var postckdevice = [];
      if (this.isGroupPost == true) {
        if (this.radio1 != null) {
          postckdevice.push({ VDeviceId: this.radio1.VDeviceId, DeviceName: this.radio1.DeviceName, ChannelId: this.radio1.ChildId != null ? this.radio1.ChildId : this.radio1.ChannelId })
        }
      } else {
        this.checkDevice.forEach(n => {
          postckdevice.push({
            VDeviceId: n.VDeviceId,
            DeviceName: n.DeviceName,
            ChannelId: n.ChildId != null ? n.ChildId : n.ChannelId,
            ParentVDeviceId: n.ParentVDeviceId
          })
        })
      }
      const posttrigger = [{ VDeviceId: this.sensormodel.VDeviceId, DeviceName: this.sensormodel.DeviceName }]
      let para = {
        GpNo: this.areaid,
        Mode: this.modetype,
        ConstIlluminationType: this.isGroupPost ? 0 : 1, // this.constIlluminationtype,
        TriggerList: posttrigger,
        DeviceList: postckdevice,
        SegmentList,
        ConstIlluminationName: this.name
      }
      this.loading = true
      if (this.name == '') { this.name = this.$t('iftttset.illumination') }
      if (this.constIlluminationModel != null) {
        para.ConstIlluminationNo = this.constIlluminationModel.ConstIlluminationNo
        para.ConstIlluminationName = this.name// this.constIlluminationModel.ConstIlluminationName;
        Edit(para, this.functionDoNotice)
      } else {
        Create(para, this.functionDoNotice)
      }
      console.log(para)
      para = null
    },
    /* 执行添加恒照度 接口返回处理
    * rs:接口返回数据包
    */
    functionDoNotice (rs, para) {
      this.loading = false
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode)
        this.$emit('LightStepOK', para.GpNo)
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    /* 执行添加恒照度
    */
    LightStepOK () {
      // this.$emit('LightStepOK');
      this.doCreate()
    },
    /* 跳到第二步
    */
    goStep3 () {
      // if (this.tempsensormodel != null) {
      // 	if (this.sensormodel != null) {
      // 		if (this.sensormodel.VDeviceId == this.tempsensormodel.VDeviceId && this.sensormodel.ChildId == this.tempsensormodel.ChildId) {
      // 			if (this.constIlluminationModel != null) {
      // 				this.doFindDeviceListByPage();
      // 				this.tempsensormodel = null;
      // 			} else {
      // 				this.LightStep = 3;
      // 			}
      // 		} else {
      // 			this.sensormodel.StatusInfo = this.tempsensormodel;
      // 			this.doFindDeviceListByPage();
      // 			this.tempsensormodel = null;
      // 		}
      // 	} else {
      // 		this.sensormodel = this.tempsensormodel;
      // 		this.doFindDeviceListByPage();
      // 		this.tempsensormodel = null;
      // 	}

      // } else {
      // 	if (this.sensormodel != null) {
      // 		this.LightStep = 3;

      // 	} else {
      // 		warning(this, this.$t('lastLight.selectwaring'));
      // 	}
      // }
      if (this.sensormodel != null) {
        this.LightStep = 3
      } else {
        warning(this, this.$t('lastLight.selectwaring'))
        return
      }

      if (this.sensormodel != null && this.sensormodel.StatusInfo instanceof Array) {
        let _obj = this.sensormodel.StatusInfo.find(param => {
          return param.StatusType.indexOf('0x06') >= 0
        })
        if (_obj != null) {

          if (_obj.Value != null && _obj.Value != "--") { this.sensorilluminance = Number(_obj.Value); }
          if (_obj.illumination != null && _obj.illumination != "--") { this.sensorCorrection = Number(_obj.illumination); }
          this.sensorIsCorrected = _obj["IsCorrected"];
        }
        _obj = null
      }
      this.$forceUpdate()
      if (this.isGroupPost == true) {
        setTimeout(this.groupControlEvent, 100, this.isGroupPost)
      }
    },
    verifyGateway() {

      if (this.wifiData != null && this.wifiData.length > 0) {
        return true
      } else {
        warning(this, this.$t('ifttt.noFindGateWayTip'))
        return false
      }
    },
    /* 跳到第二步
    */
    firstSave () {
      // tempsensormodel
      if (this.verifyGateway()) {
        this.goStep3()
      }

      // if (this.sensormodel != null) {
      // 	this.doFindDeviceListByPage();
      // } else {
      // 	warning(this, '请选择传感器');
      // }
    },
    /* 跳到第三步 验证
    */
    secondSave () {
      if (this.checkDevice.length == 0 && this.isGroupPost == false) {
        warning(this, this.$t('lastLight.must'))
      } else {
        this.LightStep = 4
      }
    },
    /* 未使用
    */
    createGrop () {
      if (this.LightStep < 5) {
        this.LightStep = this.LightStep + 1
      } else {
        this.LightStep = 5
        this.dosocket()
      }
    },
    /* 注册socket
    */
    dosocket () {
      // 传感器赋值初始值

      postWebIOSocket('sync_info_add_event', { data: [{ projectCode: this.$store.state.projectcode, type: 1, id: this.sensormodel.VDeviceId }] })

      // if(this.sensormodel!=null){
      // 		//注册socket
      // 		// var para={data:[{projectCode:this.$store.state.projectcode,type:1,id:this.sensormodel.VDeviceId}]};
      // 		// socket.emit('sync_info_add_event', para);
      // 		//console.log(para);
      // 	if(this.constIlluminationModel==null){
      // 		if(this.sensormodel.StatusInfo!=""){
      //
      //       var _list;
      //       if(typeof this.sensormodel.StatusInfo == "string"){
      //         _list=JSON.parse(this.sensormodel.StatusInfo);
      //       }else{
      //         _list=this.sensormodel.StatusInfo;
      //       }
      // 			var _model=null;
      // 			if(_list!=null){
      // 				_list.forEach(n=>{
      // 					if(n.Type=="0x0600"){
      // 						_model=n;
      // 					}
      // 				})
      // 			}
      // 			if(_model!=null){
      // 				this.sensorilluminance=Number(_model.Value);
      // 			}

      // 			_list=null;
      // 			_model=null;
      // 			//para=null;
      // 		}
      // 	}

      // }
    },
    /* 未使用
    */
    removeTree2 () {
      /* console.log('removeTree2');	 */
    },
    /* 未使用
    */
    cardset () {
      this.card_set = true
    },
    /* 未使用
    */
    load () {
      this.count += 2
    },
    /* 未使用
    */
    checkboxSelect (index) {
      const onlyCheck = this.$data.card_list2[index].checked
      console.log('onlyCheck =' + onlyCheck)
    },
    /* 全选
    */
    checkAll (e) {
      if (e) {
        this.select = true
      } else {
        this.select = false
      }
      this.selectCheckBox(e)
    },
    /* 执行全选操作
    */
    selectCheckBox (_flag) {
      let _arr = []
      this.card_list.forEach(item => {
        if (!item.isdisabled) {
          item.ischecked = _flag // 全选
        }
        _arr.push(item)
      })
      this.cardlist = _arr
      this.getCheckedDataDevice()
      _arr = null
    },
    // 20230811 设备选择选中全选，表示选中区控
    //通过选中卡片的checkbox 或者通过全选，来判断是否是区控
    changeGroupPost(val,show){
      this.isGroupPost=val
      this.$refs.deviceSelect.setGroupControlValue(this.isGroupPost);
      if(show){
        // info(this,this.$t('hcl.warning7'))

        this.$alert(this.$t('hcl.warning7'), '', {
          confirmButtonText: this.$t('user.yes'),
          callback: action => {
          }
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.lux_tab_box {
  background-color: rgba(255, 255, 255, 0.5);
  -webkit-box-shadow: 2px 3px 16px 0px rgba(141, 165, 197, 0.06);
  box-shadow: 2px 3px 16px 0px rgba(141, 165, 197, 0.06);
  border-radius: 10px;
  padding: 10px;
  margin: 10px;
}
.lux_slider_cont.complete-line {
  display: flex;
  align-items: center;
}
.constillumset_box{
  width: 937px;
  height:22px;
  font-size: 12px;
  color:#8C8C8C;
  text-align: center;
  margin: 26px auto;
  padding-top: 6px;
}
.height_set {
  padding-top: 24px;
}
.lux_slider_switch {
  display: flex;
  align-items: center;
  margin-right: 10px;
  span {
    white-space: nowrap;
    margin-right: 5px;
  }
}
</style>
